import React, { useState } from "react";
import Popup from "../../../components/Popups/Popup";
import SaveButton from "../../../components/Buttons/SaveButton";
import FileUploadField from "../../../components/Fields/FileUploadField";
import SelectListField from "../../../components/Fields/SelectListField";
import TextboxField from "../../../components/Fields/TextboxField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import { useNotifications } from "../../../contexts/notificationContext";
import FileCreateResultModel from "../../../models/FileCreateResultModel";
import DataService from "../../../services/data.service";
import { UserPopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";

interface UserAttachmentCreateModel {
    userId: number
    attachmentTypeId: number
    attachmentName?: string
    fileName?: string
    fileResult?: FileCreateResultModel
}

const AddUserAttachmentPopup: React.FC<UserPopupProps> = ({ show, onHide, userId }) => {
    const [file, setFile] = useState<File>();
    const [serverErrors, setServerErrors] = useState<DataResult<UserAttachmentCreateModel>>({ isSuccesful: true, messages: [], data: undefined });
    const attachmentTypes = useSelectListOptions('api/v1/selectlist/AttachmentTypesForUser', '-- Select attachment type');

    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<UserAttachmentCreateModel>({
        userId: userId,
        attachmentTypeId: 0,
    });

    function submit() {
        if (formData && file) {
            DataService
                .createFile(file)
                .then(fileResponse => {
                    handleResult(fileResponse);
                    if (fileResponse.isSuccesful === true && fileResponse.data) {
                        formData.fileResult = fileResponse.data;
                        DataService
                            .create<UserAttachmentCreateModel>(`api/v1/UserAttachments`, formData)
                            .then(response => {
                                handleResult(response);
                                setServerErrors(response);
                                if (response.isSuccesful === true) {
                                    if (onHide)
                                        onHide();
                                }
                            })
                            .catch(e => handleException(e));
                    }
                    else {
                        handleResult(fileResponse);
                    }
                })
                .catch(e => handleException(e));
        }
    }

    function onFieldChanged(name: string, value: string | File): void {
        if (name === 'fileName' && typeof (value) === 'object') {
            setFile(value);
            formData.fileName = value.name;
            formData.attachmentName = value.name;
        }
        else {
            formData[name] = value;
        }
        setFormData(formData);
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'attachmentName', label: 'Name', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
            { name: 'attachmentTypeId', label: 'Type', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
            { name: 'fileName', label: 'File', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        handleFieldChanged: onFieldChanged,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add Attachment'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('attachmentTypeId')} options={attachmentTypes} />
                <FileUploadField {...getFieldProps('fileName')} />
                <TextboxField {...getFieldProps('attachmentName')} disabled />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton text='Add' {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default AddUserAttachmentPopup;